import React from 'react';
import { CHECKOUT_URL, PRICE_VALUE, PRODUCT_NAME } from '../data/halloweenKit';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  className?: string;
};

/** Goes to checkout once CHECKOUT_URL is set; until then it scrolls to the offer block. */
export function CtaButton({
  label,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-4 py-[1.05rem] text-[12px] tracking-[0.05em] min-[400px]:text-[13px] sm:px-8 sm:py-[1.15rem] sm:text-[15px] sm:tracking-[0.08em]' : 'px-4 py-4 text-[12px] tracking-[0.05em] min-[400px]:text-[12.5px] sm:px-6 sm:text-[13.5px] sm:tracking-[0.08em]';
  const href = CHECKOUT_URL ?? '#offer';
  return <a href={href} onClick={CHECKOUT_URL ? () => trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    value: PRICE_VALUE,
    currency: 'USD'
  }) : undefined} className={`inline-flex w-full min-w-0 max-w-md items-center justify-center whitespace-nowrap rounded-full bg-pumpkin text-center font-sans font-bold uppercase text-night-950 shadow-lift transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-pumpkin-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-pumpkin active:translate-y-0 ${sizeClasses} ${className}`} data-id="element-64" data-mp="vddcnknn4pd9">
      {label}
    </a>;
}